<template>
  <div class="content-wrap">
    <div
      class="scroll-draw"
      :style="{
        transform: `translate(${ scrollLeft }px)`,
        width: 434 * otherDrawList.length + 'px',
      }"
      @transitionend="transitionEnd"
    >
      <div
        v-for="(d, i) in otherDrawList"
        :key="'draw' + i"
        class="scroll-one-draw"
      >
        <div class="draw-nickname">{{ d.nickname }}</div>
        <div class="draw-name">剛獲得{{ d.detail }}</div>
      </div>
    </div>
    <DrawCircle
      v-model="count"
      ref="draw_circle"
      @getdefaultdata="getDefaultData"
      @canopenrewards="canOpenRewards = $event"
      @showdrawdialog="drawDialog"
    />
    <div class="activity-time">距離活動截止倒計時</div>
    <div class="activity-time-2">
      <span class="num">{{ 10 > day ? ('0' + day) : day }}</span>
      <span class="text">天</span>
      <span class="num">{{ 10 > hour ? ('0' + hour) : hour }}</span>
      <span class="text">時</span>
      <span class="num">{{ 10 > min ? ('0' + min) : min }}</span>
      <span class="text">分</span>
      <span class="num">{{ 10 > secound ? ('0' + secound) : secound }}</span>
      <span class="text">秒</span>
    </div>
    <div class="draw-count">
      <img class="timo" src="./images/timo.png">
      <div class="count-num">剩余抽奖次数:<span>{{ count }}</span></div>
      <div class="need-price">
        <div>距離下一次抽獎機會還差{{ needCount }}幣</div>
        <div>（僅限英雄聯盟訂單）</div>
      </div>
      <button @click="handleShowDraw">我的獎品</button>
    </div>
    <div class="activity-rule">
      <div class="activity-rule-title">
        <img class="mobile-img" src="./images/title-line.png">
        <img class="pc-img" src="./images/title-line-pc.png">
        <span>活動詳情</span>
        <img class="mobile-img" src="./images/title-line.png" style="transform: scaleX(-1)">
        <img class="pc-img" src="./images/title-line-pc.png" style="transform: scaleX(-1)">
      </div>
      <div class="activity-rule-wrap">
        <div class="content-left">
          <div class="activity-rule-h1">活動時間：</div>
          <div class="activity-rule-content ">2021年2月8日-2月18日</div>
          <div class="activity-rule-h1 activity-rule-h1-2">活動規則：</div>
          <div class="activity-rule-content">1. 活動期間內，系統會根據用戶完成的英雄聯盟訂單金額發放抽獎機會，首次消費任意金額即可獲得一次抽獎機會，金額每滿200即可額外獲得一次機會。如：活動開始後在英雄聯盟完成訂單金額1000，則可以獲得抽獎機會為1+5=6次</div>
          <div class="activity-rule-content with-last">2. 100%中獎，您可能會抽中滿減券、nicee幣、英雄聯盟造型、英雄聯盟改名卡等道具，活動獎品請以中獎頁面實際展示為準</div>
          <div class="activity-rule-content with-last">（小叮嚀：抽的次數越多，抽中造型的機率越大喔～)</div>
        </div>
        <div class="content-right">
          <div class="activity-rule-h1 activity-rule-h1-3">獎勵發放：</div>
          <div class="activity-rule-content">1. 優惠券類的獎品將在中獎起3個工作日內到達您的帳戶；根據LOL本地營運商的要求，贈送造型需成為14天遊戲內好友，造型類的獎品將在客服添加您遊戲好友之後的15個工作日到達您的英雄聯盟帳戶裡</div>
          <div class="activity-rule-content with-last">2. 可以在“我的獎品”中查詢到中獎紀錄</div>
          <div class="activity-rule-content title-box">本活動客服僅會用官方“客服小助手”與您聯繫，請注意不要與非此帳戶透露您的遊戲id</div>
          <div class="activity-rule-content with-last">本活動最終解釋權歸nicee所有</div>
        </div>
      </div>
    </div>
    <div class="bottom-bc" />
    <el-dialog
      :visible.sync="showAllDraw"
      class="dialog-clear-style draw-popup"
      :close-on-click-modal="false"
      append-to-body
      width="310px"
      top="20vh"
    >
      <div class="draw-list">
        <div class="draw-list-title" />
        <div class="line" />
        <div class="draws-list">
          <template v-if="drawsList.length">
            <div
              v-for="(d, i) in drawsList"
              :key="i"
              class="one-draw"
            >
              <span class="draw-name">{{ d.detail }}</span>
              <span class="draw-time">{{ d.createTime }}</span>
            </div>
          </template>
          <div
            v-else
            class="no-draw"
          >
            <span class="draw-name">你還沒有中獎紀錄呦</span>
            <span class="draw-time" />
          </div>
        </div>
        <div class="line" />
        <div class="tip-title">注意事項：</div>
        <div class="tip-content">1. 優惠券、nicee幣類型獎品將在中獎起3個工作日內到達您的nicee錢包，請注意查收</div>
        <div class="tip-content">2. 根據LOL本地營運商的要求，贈送造型需成為14天遊戲內好友，造型類的獎品將在客服添加您遊戲好友之後的15個工作日到達您的英雄聯盟帳戶裡</div>
        <img class="close-btn pointer" src="~@/assets/image/icons/close-border-white.png" @click="showAllDraw = false">
      </div>
    </el-dialog>
    <el-dialog
      v-if="newDraw"
      :visible.sync="showDrawDialog"
      class="dialog-clear-style draw-popup"
      :close-on-click-modal="false"
      append-to-body
      width="267px"
      top="20vh"
    >
      <div class="draw-info">
        <div class="draw-info-title">中獎啦，手氣不錯！</div>
        <div class="draw-info-title">恭喜您獲得</div>
        <img class="draw-img" :src="require(`./images/reward-${newDraw.code === 5 ? 3 : newDraw.code}.png`)">
        <div class="reward-name">{{ newDraw.detail }}</div>
        <div class="buttons" :style="!count && 'justify-content: center;'">
          <button class="my-reward" @click="showDrawDialog = false; showAllDraw = true;">我的獎品</button>
          <button v-if="count" class="play-again" @click="$refs.draw_circle.play(); showDrawDialog = false">再抽一次</button>
        </div>
        <img class="close-btn pointer" src="~@/assets/image/icons/close-border-white.png" @click="showDrawDialog = false">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DrawCircle from './draw-circle'
export default {
  components: {
    DrawCircle,
  },
  data() {
    return {
      nativeType: this.$util.nativeType,
      day: 0,
      hour: 0,
      min: 0,
      secound: 0,
      count: 0,
      needCount: 0,
      showAllDraw: false,
      drawsList: [],
      canOpenRewards: true, // 是否可以打開我的禮品
      showDrawDialog: false, // 展示抽取的禮物信息
      scrollLeft: 0, // 距离
      otherDrawList: [],
      newDraw: null,
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.setDefaultTime()
    this.getLastTime()
    this.getDefaultData()
    this.getOtherDrawList()
  },
  mounted() {
    this.$adjust('web_raffle_view', {})
  },
  methods: {
    transitionEnd() {
      this.scrollLeft -= 100
    },
    getOtherDrawList() {
      this.$http.get('/activity/lolLottery/recentReward')
        .then(({ data }) => {
          this.otherDrawList = data.map(item => Object.assign(JSON.parse(item.reward), item))
          this.transitionEnd()
        })
    },
    drawDialog(info) {
      this.showDrawDialog = true
      this.newDraw = info
    },
    getDefaultData() {
      this.getReward()
      this.getCount()
    },
    getReward() {
      return this.$http.get('/activity/lolLottery/myReward')
        .then(({ data }) => {
          data && (this.drawsList = data.map(item => {
            const rs = Object.assign(JSON.parse(item.reward), item)
            rs.createTime = new Date(rs.createTime).$format('yyyy-MM-dd hh:mm')
            return rs
          }))
        })
    },
    getCount() {
      return this.$http.get('/activity/lolLottery/myInfo')
        .then(({ data }) => {
          if (data) {
            this.needCount = data.nextAmount
            this.count = data.remainCount
          }
        })
    },
    handleShowDraw() {
      if (!this.canOpenRewards) return
      if (!this.userInfo) {
        this.$util.Login()
        return
      }
      this.showAllDraw = true
    },
    setDefaultTime() {
      this.day = 0
      this.hour = 0
      this.min = 0
      this.secound = 0
    },
    getLastTime() {
      let time = parseInt((new Date('2021/2/19 00:00:00 GMT+0800').getTime() - Date.now()) / 1000)
      if (!this.dateList) {
        this.dateList = [
          {
            attr: 'day',
            count: 30,
          },
          {
            attr: 'hour',
            count: 24,
          },
          {
            attr: 'min',
            count: 60
          },
          {
            attr: 'secound',
            count: 60,
          }
        ]
        this.reverseList = [...this.dateList].reverse()
      }
      let base = this.dateList.reduce((rs, item) => rs * item.count, 1)
      this.dateList.forEach(item => {
        base = base / item.count
        this[item.attr] = parseInt(time / base)
        time -= this[item.attr] * base
      })
      this.subTime()
    },
    subTime() {
      this.timer = setTimeout(() => {
        this.secound--
        let i = 0
        while (this[this.reverseList[i].attr] === -1) {
          this[this.reverseList[i].attr] += this.reverseList[i].count
          if (this.reverseList[i + 1]) this[this.reverseList[i + 1].attr]--
          i++
          if (i === this.reverseList.length) {
            this.setDefaultTime()
            return
          }
        }
        this.subTime()
      }, 1000)
    },
  }
}
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 599px) {
    .scroll-draw {
      position: absolute;
      top: 232px;
      left: 100%;
      transition: transform 1s linear;
      @include flex(flex-start);
      .scroll-one-draw {
        width: 265px;
        height: 28px;
        @include flex;
        border-radius: 30px;
        background: rgba($color: #0D022B, $alpha: .5);
        margin-right: 120px;
        font-size: 12px;
        line-height: 28px;
        color: rgba(255, 255, 255, .8);
        .draw-nickname {
          max-width: 120px;
          @include ellipsis;
        }
        .draw-name {
          max-width: 120px;
          @include ellipsis;
        }
      }
    }
    .content-wrap {
      background: #320806 url('./images/bc-top.png') no-repeat top center / auto 812px;
      padding: 320px 0 56px;
      @include flex(center, center, column);
      position: relative;
      .activity-time {
        margin-top: 26px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #FFEBCC;
      }
      .activity-time-2 {
        @include flex;
        margin-top: 8px;
        span {
          margin: 0 2px;
        }
        .num {
          width: 28px;
          height: 22px;
          border-radius: 1px;
          background: #FFECCE;
          box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.3);
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          text-align: center;
        }
        .text {
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          color: #FFECCE;
        }
      }
      .draw-count {
        position: relative;
        z-index: 2;
        width: 320px;
        height: 157px;
        margin-top: 28px;
        margin-right: 7px;
        background: url('./images/count-bc.png') no-repeat center center / 100%;
        position: relative;
        @include flex(flex-start);
        flex-direction: column;
        font-size: 14px;
        line-height: 20px;
        color: #804203;
        .timo {
          position: absolute;
          top: -90px;
          right: -60px;
          width: 150px;
        }
        .count-num {
          margin-top: 28px;
          @include flex;
          span {
            margin-left: 6px;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #CC4629;
          }
        }
        .need-price {
          margin-top: 4px;
          text-align: center;
        }
        button {
          font-weight: 500;
          font-size: 12px;
          line-height: 12px;
          color: #FFDCB4;
          background: linear-gradient(134.87deg, #A93618 5.07%, #A8351A 52.56%, #A7351C 88.66%);
          border: 1px solid #FFE6C4;
          border-radius: 1px;
          padding: 7px 17px;
          margin-top: 16px;
        }
      }
      .bottom-bc {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 660px;
        background: url('./images/bc-bottom.png') repeat-x left bottom / auto 100%;
      }
    }
    .activity-rule {
      position: relative;
      z-index: 2;
      margin: 40px auto 0;
      width: 306px;
      text-align: left;
      font-size: 14px;
      line-height: 22px;
      color: #FFE6C4;
      &-title {
        @include flex(space-between);
        width: 100%;
        margin-bottom: -4px;
        .pc-img {
          display: none;
        }
        .mobile-img {
          width: 110px;
        }
        span {
          font-weight: 500;
          font-size: 16px;
        }
      }
      &-h1 {
        font-weight: 500;
        margin-top: 16px;
      }
      &-content {
        opacity: .85;
        margin-top: 6px;
        &.with-last {
          margin-top: 0;
        }
        &.title-box {
          margin-top: 16px;
        }
      }
    }
    .draw-list {
      width: 310px;
      background: #FFEBCE;
      border: 3px solid #AA3428;
      border-radius: 2px;
      padding: 0 16px 17px;
      font-size: 12px;
      line-height: 18px;
      color: #6B2616;
      text-align: left;
      position: relative;
      &-title {
        height: 58px;
        background: url('./images/my-draw-title.png') no-repeat center center / 106px;
      }
      .line {
        height: 1px;
        background: #8E5A17;
        opacity: .2;
      }
      .draws-list {
        padding: 20px 0;
        max-height: 240px;
        min-height: 136px;
        overflow-y: auto;
        @include hideScrollBar(0, 0);
        .one-draw {
          @include flex(space-between);
          &:not(:first-child) {
            margin-top: 16px;
          }
          .draw-name {
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
            color: #6B2616;
          }
          .draw-time {
            font-size: 12px;
            line-height: 20px;
            color: #6B2616;
            opacity: 0.8;
          }
        }
        .no-draw {
          height: 96px;
          font-size: 13px;
          line-height: 18px;
          color: #6B2616;
          opacity: .4;
          @include flex;
        }
      }
      .tip-title {
        font-weight: 500;
        margin-top: 12px;
      }
      .tip-content {
        opacity: 0.85;
        margin-top: 8px;
      }
      .close-btn {
        position: absolute;
        width: 31px;
        left: 50%;
        top: 100%;
        transform: translate(-50%, 30px);
      }
    }
    .draw-info {
      width: 267px;
      background: #C73F3F;
      border: 3px solid #E37F6D;
      border-radius: 2px;
      padding: 21px 15px 19px;
      color: #FFECCC;
      text-align: center;
      position: relative;
      &-title {
        line-height: 24px;
        font-size: 17px;
        font-weight: 500;
      }
      .draw-img {
        width: 56px;
        margin-top: 20px;
      }
      .reward-name {
        font-size: 14px;
        line-height: 20px;
      }
      .buttons {
        @include flex(space-between);
        margin-top: 24px;
        width: 100%;
        &>button {
          width: 111px;
          height: 40px;
          font-weight: 500;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
        }
        .my-reward {
          background: linear-gradient(180deg, #AB3935 0%, #A43431 100%);
          border: 1px solid #E95551;
          border-radius: 1px;
          color: #FFECCC;
        }
        .play-again {
          color: #804203;
          background: linear-gradient(180deg, #F9DEB6 0%, #EBC291 100%);
          border: 1px solid #FFFFC6;
          border-radius: 1px;
        }
      }
      .close-btn {
        position: absolute;
        width: 31px;
        left: 50%;
        top: 100%;
        transform: translate(-50%, 30px);
      }
    }
  }
  @media screen and (min-width: 600px) {
    .scroll-draw {
      position: absolute;
      top: 6px;
      left: 100%;
      transition: transform 1s linear;
      @include flex(flex-start);
      .scroll-one-draw {
        width: 314px;
        height: 36px;
        @include flex;
        border-radius: 30px;
        background: rgba($color: #0D022B, $alpha: .5);
        margin-right: 120px;
        font-size: 14px;
        line-height: 28px;
        color: rgba(255, 255, 255, .8);
        .draw-nickname {
          max-width: 152px;
          @include ellipsis;
        }
        .draw-name {
          max-width: 130px;
          @include ellipsis;
        }
      }
    }
    .content-wrap {
      background: #320806 url('./images/bc-top-pc.png') no-repeat top center / auto 1080px;
      padding: 926px 0 489px;
      @include flex(center, center, column);
      position: relative;
      .activity-time {
        position: absolute;
        right: 50%;
        top: 646px;
        transform: translate(-170px);
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #FFEBCC;
      }
      .activity-time-2 {
        position: absolute;
        right: 50%;
        top: 698px;
        transform: translate(-82px);
        @include flex;
        span {
          margin: 0 6px;
        }
        .num {
          width: 48px;
          height: 40px;
          border-radius: 1px;
          background: #FFECCE;
          box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.3);
          font-weight: 500;
          font-size: 24px;
          line-height: 40px;
          text-align: center;
        }
        .text {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          color: #FFECCE;
        }
      }
      .draw-count {
        position: absolute;
        top: 632px;
        left: 50%;
        transform: translate(100px);
        z-index: 2;
        width: 405px;
        height: 206px;
        background: url('./images/count-bc.png') no-repeat center top / 100%;
        @include flex(flex-start);
        flex-direction: column;
        font-size: 16px;
        line-height: 22px;
        color: #804203;
        .timo {
          position: absolute;
          top: -90px;
          right: -60px;
          width: 150px;
        }
        .count-num {
          margin-top: 30px;
          @include flex;
          span {
            margin-left: 12px;
            font-weight: 500;
            font-size: 22px;
            line-height: 24px;
            color: #CC4629;
          }
        }
        .need-price {
          margin-top: 8px;
          font-weight: 500;
          text-align: center;
        }
        button {
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          color: #FFDCB4;
          background: linear-gradient(134.87deg, #A93618 5.07%, #A8351A 52.56%, #A7351C 88.66%);
          border: 1px solid #FFE6C4;
          border-radius: 1px;
          padding: 11px 29px;
          margin-top: 13px;
        }
      }
      .bottom-bc {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 815px;
        background: url('./images/bc-bottom-pc.png') repeat-x left bottom / auto 100%;
      }
    }
    .activity-rule {
      position: relative;
      z-index: 2;
      margin: 0 auto;
      width: 1100px;
      text-align: left;
      font-size: 14px;
      line-height: 22px;
      color: #FFE6C4;
      &-title {
        @include flex(space-between);
        width: 100%;
        margin-bottom: -8px;
        .pc-img {
          width: 487px;
        }
        .mobile-img {
          width: 0;
        }
        span {
          font-weight: 500;
          font-size: 24px;
          line-height: 34px;
        }
      }
      &-h1 {
        font-weight: 500;
        &-2 {
          margin-top: 16px;
        }
      }
      &-content {
        opacity: .85;
        margin-top: 12px;
        &.with-last {
          margin-top: 0;
        }
        &.title-box {
          margin-top: 32px;
        }
      }
      &-wrap {
        @include flex(space-between, flex-start);
        margin-top: 40px;
        border-bottom: 1px solid #FFE6C4;
        padding-bottom: 48px;
        & > div {
          width: 510px;
        }
      }
    }
    .draw-list {
      width: 310px;
      background: #FFEBCE;
      border: 3px solid #AA3428;
      border-radius: 2px;
      padding: 0 16px 17px;
      font-size: 12px;
      line-height: 18px;
      color: #6B2616;
      text-align: left;
      position: relative;
      &-title {
        height: 58px;
        background: url('./images/my-draw-title.png') no-repeat center center / 106px;
      }
      .line {
        height: 1px;
        background: #8E5A17;
        opacity: .2;
      }
      .draws-list {
        padding: 20px 0;
        max-height: 240px;
        min-height: 136px;
        overflow-y: auto;
        @include hideScrollBar(0, 0);
        .one-draw {
          @include flex(space-between);
          &:not(:first-child) {
            margin-top: 16px;
          }
          .draw-name {
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
            color: #6B2616;
          }
          .draw-time {
            font-size: 12px;
            line-height: 20px;
            color: #6B2616;
            opacity: 0.8;
          }
        }
        .no-draw {
          height: 96px;
          font-size: 13px;
          line-height: 18px;
          color: #6B2616;
          opacity: .4;
          @include flex;
        }
      }
      .tip-title {
        font-weight: 500;
        margin-top: 12px;
      }
      .tip-content {
        opacity: 0.85;
        margin-top: 8px;
      }
      .close-btn {
        position: absolute;
        width: 31px;
        left: 50%;
        top: 100%;
        transform: translate(-50%, 30px);
      }
    }
    .draw-info {
      width: 267px;
      background: #C73F3F;
      border: 3px solid #E37F6D;
      border-radius: 2px;
      padding: 21px 15px 19px;
      color: #FFECCC;
      text-align: center;
      position: relative;
      &-title {
        line-height: 24px;
        font-size: 17px;
        font-weight: 500;
      }
      .draw-img {
        width: 56px;
        margin-top: 20px;
      }
      .reward-name {
        font-size: 14px;
        line-height: 20px;
      }
      .buttons {
        @include flex(space-between);
        margin-top: 24px;
        width: 100%;
        &>button {
          width: 111px;
          height: 40px;
          font-weight: 500;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
        }
        .my-reward {
          background: linear-gradient(180deg, #AB3935 0%, #A43431 100%);
          border: 1px solid #E95551;
          border-radius: 1px;
          color: #FFECCC;
        }
        .play-again {
          color: #804203;
          background: linear-gradient(180deg, #F9DEB6 0%, #EBC291 100%);
          border: 1px solid #FFFFC6;
          border-radius: 1px;
        }
      }
      .close-btn {
        position: absolute;
        width: 31px;
        left: 50%;
        top: 100%;
        transform: translate(-50%, 30px);
      }
    }
  }
</style>
